<template>
    <div class="pricing">
        <div class="available" v-if="!isWishListPage && !isBasketPage && !isStandPage && isProductDetailsPage">
            <div>
                <div v-if="available > 0" class="in-stock" :class="{activeStock: openBasket}">
                    <span @dblclick="toggleShowingStock" v-text="__('vue.product-pricing.in-stock')"></span>

                    <div v-if="showStock"
                         class="show-stock card card-body d-flex flex-row align-items-center justify-content-between mb-4">
                        <span>
                            {{ available }} {{ __('vue.product-pricing.units-available') }}
                        </span>
                        <button @click="showStock = false" type="button" class="ml-2 btn btn-sm btn-warning">
                            {{ __('vue.generic.hide') }}
                        </button>
                    </div>
                </div>
                <!--
                <div class="_count" :class="{activeCount: openBasket}">
                    {{ available }} units available
                </div>
                -->
            </div>
        </div>
        <div class="h-lg-100">
            <div v-if="isLoggedIn && openBasket" class="h-lg-100">
                <div class="basket h-lg-100">
                    <div class="basket-container h-lg-100">
                        <div class="wishlist-button listviewWishlist d-none"
                             v-if="!isBasketPage && !isWishListPage && !isStandPage && !isProductDetailsPage">
                            <div class="full-icon cursor-pointer" @click="toggleToWishListItem"
                                 :class="wishListId ? 'wishlist' : ' ' ">
                                <i v-if="!wishListId" class="fa-regular fa-heart"></i>
                                <i v-else class="fa-solid fa-heart"></i>
                            </div>
                        </div>
                        <div>
                            <div @dblclick="openBasketRep" class="basket-item" v-if="customerId && !isBasketPage">
                                <p v-if="!specificPrice" class="small grid-view-pricing">
                                    <span v-for="(price, key) in product.orderedPrices" :key="key">
                                        <span v-html="currency.symbol"></span>{{
                                            price.price | currencyDecimals
                                        }} <span v-text="__('vue.product-pricing.ea')"></span> /{{ price.quantity }}
                                        <span v-if="key !== (product.orderedPrices.length - 1)">
                                            <span v-text="__('vue.product-pricing.or') + ' '"></span>
                                        </span>
                                    </span>
                                </p>
                                <p v-else class="small grid-view-pricing">
                                    <span class="text-decoration-line-through" v-if="oldPrice > currentPrice">
                                        <span v-html="currency.symbol"></span>{{
                                            oldPrice | currencyDecimals
                                        }}
                                    </span>

                                    <span>
                                        <span v-html="currency.symbol"></span>{{
                                            currentPrice | currencyDecimals
                                        }}
                                        <span v-text="__('vue.product-pricing.ea')"></span> /{{
                                            product.orderedPrices[0].quantity
                                        }}
                                    </span>
                                </p>
                            </div>

                            <div v-if="isBasketPage" class="basket-pricing-single">
                                <p class="mb-0"
                                   :class="{'color-light-green': product.clearancePrice, 'color-primary-green': !product.clearancePrice}"
                                   v-if="!basketItem || !basketItem.children_unit_price_ex_vat_total">
                                    <b><span v-html="currency.symbol"></span>{{ basketItem.unit_price_ex_vat | currencyDecimals }}</b>
                                </p>
                                <p :class="{'color-light-green': product.clearancePrice, 'color-primary-green': !product.clearancePrice}" class="mb-0 font-vag-bold" v-else>
                                    <b><span v-html="currency.symbol"></span>{{
                                            basketItem.children_unit_price_ex_vat_total | currencyDecimals
                                        }}</b>
                                </p>
                            </div>

                            <div class="basket-count"
                                 :class="{'basket-count-product-page': isProductDetailsPage, 'mt-3 mt-lg-0': activeList }"
                                 v-if="customerId && ((standEditIsEnabled && isStandPage) || !isStandPage ) && (available > 0 || isBackOrder) || (basketItem && !basketItem.is_grouped_back_order)">
                                <div v-if="!isBasketPage || basketItem && (!basketItem.back_order_item_id || (isBasketPage && basketItem.quantity > basketItem.back_order_added_quantity))" @click="decrementCount" @dblclick.stop>
                                    <i class="fa-solid fa-minus"></i>
                                </div>
                                <div class="editable-product-count">
                                    <input type="text" @change="manualCount($event)" v-model="productCount">
                                    <p class="small mb-0 text-center" v-text="__('vue.product-pricing.units')"></p>
                                </div>
                                <div v-show="!hideIncrement" @click="incrementCount" @dblclick.stop>
                                    <i class="fa-solid fa-plus"></i>
                                </div>
                                <div v-show="hideIncrement"></div>
                            </div>


                            <div v-if="isBasketPage && basketItem.is_grouped_back_order">
                                <p class="mb-0 color-primary-green font-vag-bold">{{basketItem.quantity}} Units</p>
                            </div>

                            <div class="oos-messages" v-if="available === 0">
                                <p v-if="isProductDetailsPage" class="font-vag-bold color-primary-orange mb-0"><b><span v-text="__('vue.product-pricing.out-of-stock')" :class="{'px-2': activeList, 'mt-3': activeGrid}" class="d-block"></span></b></p>
                                <p v-else-if="!isBasketPage" class="font-vag-bold color-primary-orange mb-0">
                                    <b v-if="!user || !user.customer || !user.customer.credit_account"><span v-text="__('vue.product-pricing.out-of-stock-click-to-see-options')" :class="{'px-2': activeList, 'mt-3': activeGrid}" class="d-block"></span></b>
                                    <b v-else><span v-text="__('vue.product-pricing.out-of-stock')" :class="{'px-2': activeList, 'mt-3': activeGrid}" class="d-block"></span></b>
                                </p>
                                <b><span v-if="(product.stock_due && !isBasketPage)" class="text-dark">Stock due {{ product.stock_due | formatDate }}</span></b>
                            </div>

                            <!--
                            <div v-if="(standEditIsEnabled && isStandPage) || !isStandPage">
                                <div class="basket-price" @dblclick="openBasketRep"
                                     v-if="!isWishListPage && !isBasketPage">
                                    <span class="prod-price">{{ totalPrice | currencyDecimals }}</span>
                                    <span class="ex-vat" v-text="__('vue.product-pricing.ex-vat')"></span>
                                </div>
                            </div>
                            -->

                            <div v-if="!standEditIsEnabled && isStandPage">
                                <p class="font-vag-bold"><b>{{ productCount }} <span
                                    v-text="__('vue.product-pricing.units')"></span></b></p>
                                <div class="product-card-edit">
                                    <p class="mb-0 font-vag-bold">
                                        <span><b><span
                                            v-text="__('vue.product-pricing.pocket')"></span> {{ standPocketNumber }} - <span
                                            v-html="currency.symbol"></span>{{
                                                totalPrice | currencyDecimals
                                            }}</b></span>
                                        <span @click="pocketEditMode"><i class="fa-regular fa-pencil"></i></span>
                                    </p>
                                </div>
                            </div>
                            <div v-if="standEditIsEnabled && isStandPage">
                                <p class="small mt-2 srp-pricing"><span v-text="__('vue.product-pricing.srp')"></span>:
                                    <span v-if="product.srp">
                                        <span v-html="currency.symbol"></span>
                                        {{ product.srp.srp | currencyDecimals }}
                                    </span>
                                    <span v-else>
                                        ---
                                    </span>

                                </p>
                                <div class="product-card-edit">
                                    <p class="mb-0 font-vag-bold">
                                        <span><b><span
                                            v-text="__('vue.product-pricing.pocket')"></span> {{ standPocketNumber }} - <span
                                            v-html="currency.symbol"></span>{{
                                                totalPrice | currencyDecimals
                                            }}</b></span>
                                        <span @click="pocketEditMode"><i class="fa-solid fa-check"></i></span>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <!-- TODO: Is the below if statement correct? -->
                        <div v-if="isBackOrder || (available > 0)" :class="{'mt-auto': activeGrid}">
                            <div @toggleToWishListItem="toggleToWishListItem" v-if="customerId">
                                <add-to-basket
                                    :product="product"
                                    :quantity="+productCount"
                                    :wishListId="wishListId"
                                    :is-wish-list-page="isWishListPage"
                                    :is-basket-page="isBasketPage"
                                    :total-price="totalPrice"
                                    :total-old-price="totalOldPrice"
                                    :old-price="oldPrice"
                                    :currency="currency"
                                    :is-back-order="isBackOrder"
                                    :back-order-added-quantity="basketItem ? basketItem.back_order_added_quantity : null"
                                    :is-notify="isNotify"
                                    :is-stand-page="isStandPage"
                                    :is-rep="isRep"
                                    :is-customer="isCustomer"
                                    :is-call-centre="isCallCentre"
                                    :activeList="activeList"
                                    :activeGrid="activeGrid"
                                    :is-product-details-page="isProductDetailsPage"
                                    :user="user"
                                    @toggleToWishListItem="toggleToWishListItem"
                                    @removeFromList="removeFromList"
                                    @productsBasketCountUpdated="productsBasketCountUpdated"
                                />
                            </div>
                            <div v-else>
                                <p class="mb-0 no-customer" v-text="__('vue.product-pricing.no-active-customer')"></p>
                            </div>
                        </div>
                        <div v-else>
                            <span v-if="!isStandPage && customerId">
                                <add-to-basket
                                    :product="product"
                                    :quantity="+productCount"
                                    :wishListId="wishListId"
                                    :is-wish-list-page="isWishListPage"
                                    :is-basket-page="isBasketPage"
                                    :total-price="totalPrice"
                                    :total-old-price="totalOldPrice"
                                    :old-price="oldPrice"
                                    :currency="currency"
                                    :is-back-order="isBackOrder"
                                    :is-notify="isNotify"
                                    :is-stand-page="isStandPage"
                                    :is-rep="isRep"
                                    :is-customer="isCustomer"
                                    :is-call-centre="isCallCentre"
                                    :is-product-details-page="isProductDetailsPage"
                                    :is-performa=true
                                    :activeList="activeList"
                                    :activeGrid="activeGrid"
                                    :user="user"
                                    @toggleToWishListItem="toggleToWishListItem"
                                    @removeFromList="removeFromList"
                                    @productsBasketCountUpdated="productsBasketCountUpdated"
                                />
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else-if="!openBasket" @dblclick="openBasketRep">
                <div v-if="isRep" class="_cart priceAmend">
                    <div class="_remove" @click="(openBasket = !openBasket, $emit('updatePriceOverride', false))">
                        <i class="fa-solid fa-xmark"></i>
                    </div>
                    <div class="price-item">
                        <div>
                            <p class="font-vag-bold mb-0" v-if="grossProfitPercent"><b>{{ grossProfitPercent.toFixed(2) }}%</b></p>
                            <p class="small mb-0" v-if="product.cost">CP: <span
                                v-html="currency.symbol"></span>{{ product.cost.cost|currencyDecimals }}</p>
                            <p v-if="product.stock" class="small"><span v-text="__('vue.product-pricing.total-stock')"></span>:
                                {{ product.stock.quantity }}</p>
                            <p v-if="!product.stock" class="small"><span v-text="__('vue.product-pricing.total-stock')"></span>:
                                0 - Product will be backordered</p>
                        </div>
                        <div class="_price">
                            <input :class="{'red-color': lowPrice}" type="number" class="_item" step="0.01" min="0.01"
                                   v-model="repSpecialPrice">
                        </div>
                    </div>
                    <div class="date-parent d-none">
                        <div class="date_text">
                            <p v-text="__('vue.product-pricing.do-you-want-to-apply-an-expiry-date-for-this-price-change')"
                               class="small"></p>
                        </div>
                        <div class="date">
                            <input type="date" v-model="date">
                        </div>
                    </div>
                    <button class="btn btn-secondary d-flex justify-content-between align-items-center apply-btn"
                            @click="setPriceForCustomer">
                        <span v-text="__('vue.product-pricing.apply-change')"></span>
                        <i class="fa-regular fa-circle-check"></i>
                    </button>
                </div>
            </div>
            <div v-if="!isLoggedIn">
                <div v-if="isProductDetailsPage">
                    <a href="/account" class="btn btn-primary"><span
                        v-text="__('vue.product-pricing.log-in-to-view-pricing')"></span> <i
                        class="fa-regular fa-user"></i></a>

                    <a href="/apply" class="register-link" v-text="__('vue.product-pricing.register-now')"></a>
                </div>
                <div v-else class="login-bar">
                    <p class="mb-0"><b v-text="__('vue.product-pricing.log-in-to-view-pricing')"></b></p>

                    <a href="/account" class="btn btn-tertiary btn-square no-text"><i class="fa-regular fa-user"></i></a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapMutations} from "vuex";


export default {
    name: "ProductInfo",
    props: {
        index: {
            type: Number,
            default: -1
        },
        product_slug: String,
        product: Object,
        grossProfit: Number,
        isRep: Boolean,
        user: Object,
        isWishListPage: {
            default: false,
            type: Boolean
        },
        isBasketPage: {
            default: false,
            type: Boolean
        },
        isCustomer: {
            default: false,
            type: Boolean
        },
        isCallCentre: {
            default: false,
            type: Boolean
        },
        isProductDetailsPage: {
            default: false,
            type: Boolean
        },
        isStandPage: {
            default: false,
            type: Boolean
        },
        standPocketNumber: Number,
        standEditIsEnabled: {
            default: false,
            type: Boolean
        },
        wishListItem: {
            type: Object,
            default: null
        },
        wishlistDirection: {
            type: String,
            default: ''
        },
        basketItem: {
            default: null,
            type: Object
        },
        showPriceOverride: {
            default: false,
            type: Boolean
        },
        activeList: Boolean,
        activeGrid: Boolean,
    },
    data() {
        return {
            available: 0,
            getProduct: null,
            typeMedia: '',
            pathMedia: null,
            customerId: null,
            editableProductCount: null,
            setCurrentPrice: null,
            openBasket: true,
            lowestQuantity: {},
            specificPrice: null,
            priceDetails: {},
            productPrice: {},
            productCount: null,
            currency: '',
            repSpecialPrice: null,
            date: null,
            isLoggedIn: this.user,
            isNotify: false,
            isBackOrder: false,
            wishListData: {},
            wishListId: null,
            basketItemId: this.basketItem ? this.basketItem.id : null,
            updateBasketPrice: 0,
            lowPrice: false,
            initialSpecialPrice: 0,
            priceAmount: 0,
            showStock: false,
            hideIncrement: false,
            backOrderQuantity: 0,
            oldPrice: null,
        }
    },
    computed: {
        totalPrice() {
            if (this.basketItem !== null && this.basketItem.children_line_discounted_total) {
                return this.basketItem.children_line_discounted_total;
            }
            if (this.specificPrice) {
                return (this.productCount * this.specificPrice)
            }

            return (this.productCount * this.productPrice)
        },
        totalOldPrice() {
            if(this.oldPrice) {
                return(this.productCount * this.oldPrice)
            }
        },
        currentPrice() {
            if (this.specificPrice) {
                return this.specificPrice;
            }

            return this.productPrice;
        },
        grossProfitPercent() {
            let gp = 0;

            if (this.repSpecialPrice && this.product.cost) {
                gp = ((this.repSpecialPrice - this.product.cost.cost) / this.repSpecialPrice) * 100;
            } else if(this.product.gp) {
                gp = this.product.gp
            } else {
                return gp;
            }

            return gp - 15; // take off 15%
        },
    },
    watch: {
        showPriceOverride(val) {
            this.openBasket = !val;
        },
        specificPrice(val) {
            if (val === '') {
                this.specificPrice = this.currency ? this.currency.symbol : ''
            }
        },
        repSpecialPrice(newValue, oldValue) {
            this.lowPrice = false;

            //if msp exists overriten price should not be less than it
            if (
                (typeof oldValue === 'string')
                && (this.product.msp && parseFloat(this.product.msp.msp) > parseFloat(newValue))
            ) {
                notyf.dismissAll();
                notyf.open({
                    type: 'error',
                    message: this.__('vue.product-pricing.price-can-not-be-less-than') + ' ' + this.product.msp.msp
                });
                return false;
            }

            //turn overridden price red if it is less than 15%
            let percentagePrice = (parseFloat(this.initialSpecialPrice) / 100) * this.product.rep_price_warning
            if (parseFloat(newValue) <= (parseFloat(this.initialSpecialPrice) - percentagePrice)) {
                this.lowPrice = true;
            }

        },

        totalPrice(newV, oldV) {
            if (!isNaN(newV) && !isNaN(oldV)) {
                this.$emit('basketProductCountUpdated', {product_id: this.product.id, quantity: this.productCount})
            }
            if (this.isStandPage) {
                const dataBasket = {product_id: this.product.id, quantity: this.productCount, total: newV}
                if (this.index > -1) {
                    dataBasket.index = this.index
                }
                this.setBasketInfo(dataBasket)
            }
        }
    },
    mounted() {
        if (this.product.wishlist && this.product.wishlist.length) {
            this.wishListId = this.product.wishlist[0].id
        }

        if (this.user && this.user.customer && this.user.customer.currency) {
            this.currency = this.user.customer.currency;
            this.customerId = this.user.customer_id;
        }

        if (typeof this.product.orderedPrices !== 'undefined' && this.product.orderedPrices.length) {
            this.lowestQuantity = this.product.orderedPrices[0]
            this.priceDetails = this.product.orderedPrices[0]
            this.productPrice = this.product.orderedPrices[0].price
            this.productCount = this.product.orderedPrices[0].quantity
            if (this.isStandPage && this.product.pocket_quantity_recommended) {
                this.productCount = this.product.pocket_quantity_recommended
            }

            this.priceAmount = this.product.orderedPrices[1]?.quantity || 0;
        }
        if(this.product.is_stand){
            this.lowestQuantity.quantity = 1
        }

        this.initSpecificPrice();

        if (this.isBasketPage) {
            this.productCount = this.basketItem.quantity;
        }

        this.getStockAvailable();
        this.recalculatePriceWithPintBreak();
    },
    methods: {
        ...mapMutations(["setBasketInfo"]),
        pocketEditMode() {
            this.$emit('pocketEditMode', this.index)
        },
        getStockAvailable() {
            if (!this.product.stock || this.product.stock.quantity === 0 || this.productCount > this.product.stock.quantity) {
                this.isNotify = true;

                if (this.user && this.user.customer && this.user.customer.credit_account) {
                    this.isBackOrder = true;
                }

            } else {
                this.available = this.product.stock.quantity
            }

        },
        initSpecificPrice() {
            if (this.product.customer_price) {
                this.specificPrice = this.product.customer_price.price;
            }
            if (this.product.rep_customer_price) {
                this.specificPrice = this.product.rep_customer_price.customer_price;
            }

            // Clearance Price overrides all
            if(this.product.clearancePrice) {
                this.specificPrice = this.product.clearancePrice.price;
                this.getOldPrice();
            }

            this.setCurrentPrice = this.specificPrice ? this.specificPrice : this.priceDetails.price

            this.repSpecialPrice = parseFloat((this.specificPrice ?? this.priceDetails.price)).toFixed(2);
            this.initialSpecialPrice = this.repSpecialPrice;

            this.$emit('setBasketItemPrices', this.currentPrice, this.specificPrice);

        },
        incrementCount() {

            if (this.hideIncrement && this.isStandPage) {
                return false;
            }

            // Check stock.
            if (!this.checkStock((this.productCount + this.lowestQuantity.quantity))) {
                return false;
            }

            this.priceDetails = this.lowestQuantity;

            if (this.productCount < this.lowestQuantity.quantity) {
                this.productCount = this.lowestQuantity.quantity;
            } else {
                let newProductCount = this.lowestQuantity.quantity + this.productCount;
                newProductCount = Math.round(newProductCount / this.lowestQuantity.quantity) * this.lowestQuantity.quantity;
                this.productCount = newProductCount;
            }

            this.recalculatePriceWithPintBreak();
            this.emitBasketCountUpdate();

        },
        emitBasketCountUpdate() {
            let itemsToUpdate = {
                'product_id': this.priceDetails.product_id,
                'quantity': this.productCount,
                'is_stand': this.product.is_stand
            }

            if(this.isBasketPage){
                itemsToUpdate.saved_quantity = this.basketItem.quantity
            }

            if (this.isBasketPage) {
                this.$emit('updateBasketQuantity', itemsToUpdate);
            }
        },
        setProductCount(quantity) {
            this.productCount = quantity
        },
        decrementCount() {
            this.hideIncrement = false

            // do not allow decrement when reached to minimum
            if (this.productCount <= this.lowestQuantity.quantity) {
                return false;
            }

            if (!this.checkStock((this.productCount - this.lowestQuantity.quantity))) {
                return false;
            }

            // only for stand check pocket_quantity_minimum from `products` table
            if (this.isStandPage) {
                if ((this.productCount - this.lowestQuantity.quantity) < this.product.pocket_quantity_minimum) {
                    notyf.dismissAll();
                    notyf.open({
                        type: 'error',
                        message: this.__('vue.product-pricing.quantity-can-not-be-lower-than-the-minimum-order-quantity')
                    });
                    return false;
                }
            }

            this.priceDetails = this.lowestQuantity
            let newProductCount = this.productCount - this.lowestQuantity.quantity;
            newProductCount = Math.round(newProductCount / this.lowestQuantity.quantity) * this.lowestQuantity.quantity;
            if (newProductCount !== 0) {
                this.productCount = newProductCount;
            } else {
                this.productCount = this.lowestQuantity.quantity;
            }

            this.recalculatePriceWithPintBreak();
            this.emitBasketCountUpdate();
        },
        checkStock(currentCount) {
            if (this.product.stock && !this.isBackOrder && currentCount > this.product.stock.quantity && (!this.user || !this.user.customer || !this.user.customer.credit_account)) {
                notyf.dismissAll();
                notyf.open({
                    type: 'error',
                    message: this.__('vue.product-pricing.insufficient-stock'),
                });

                if (this.isStandPage) {
                    this.hideIncrement = true
                }

                return false;
            }

            return true;
        },
        recalculatePriceWithPintBreak() {
            if (this.specificPrice) {
                this.getOldPrice();
                return;
            }

            if (typeof this.product.orderedPrices !== 'undefined' && this.product.orderedPrices.length > 0) {
                for (let i = this.product.orderedPrices.length - 1; i >= 0; i--) {
                    if (this.productCount >= this.product.orderedPrices[i].quantity) {
                        this.priceDetails = this.product.orderedPrices[i];
                        this.productPrice = this.product.orderedPrices[i].price;
                        this.repSpecialPrice = this.productPrice;
                        break;
                    }
                }
            }
        },
        openVideo(media) {
            this.typeMedia = media.type;
            this.pathMedia = media.path;
        },
        openBasketRep() {
            if (this.isRep === true) {
                this.openBasket = !this.openBasket;
                this.$emit('updatePriceOverride', false);
            }
        },
        setPriceForCustomer() {
            let productData =
                {
                    customer_price: this.repSpecialPrice,
                    product_id: this.product.id,
                    expiry_date: this.date,
                };

            axios
                .post("/api/rep/product/customer/price", productData)
                .then(res => {
                    if (res.data && res.data.success && res.data.basket) {
                        this.$root.$emit('basketUpdated', res.data.basket);
                        this.specificPrice = this.repSpecialPrice;
                        this.openBasket = !this.openBasket;
                        this.$emit('updatePriceOverride', false);
                        this.$emit('setBasketItemPrices', this.currentPrice, this.specificPrice);
                    }
                })
                .catch(error => {
                    notyf.dismissAll();
                    notyf.open({
                        type: 'error',
                        message: error.response.data.message
                    });
                });
        },
        toggleToWishListItem() {
            if (!this.wishListId) {
                axios
                    .post(`/api/wishlist`, {product_id: this.product.id})
                    .then(res => {
                        if (res.data.wishListData) {
                            this.wishListId = res.data.wishListData
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    });
            } else {
                this.removeFromWishList();
            }
        },
        removeFromList(payload) {
            if (payload === 'wish_list') {
                this.removeFromWishList()
            } else if (payload === 'basket') {
                this.removeFromBasket();
            }
        },
        removeFromBasket() {
            let products = {
                'products': {basket_item_id: this.basketItemId}
            };

            axios.post(`/api/basket/remove`, products)
                .then(response => {
                    this.$emit('deleteFromBasket', response.data.basket)
                })
                .catch(error => {
                    console.log(error);
                });
        },
        removeFromWishList() {
            if (!this.wishListId) {
                notyf.dismissAll();
                notyf.open({
                    type: 'warning',
                    message: this.__('vue.product-pricing.product-is-not-in-customers-wish-list')
                });
                return false;
            }

            axios
                .delete(`/api/wishlist/${this.product.id}`, {
                    headers: {},
                    data: {
                        direction: this.wishlistDirection
                    }
                })
                .then(response => {
                    this.wishListId = null
                    this.$emit('deleteFromWishList', response.data)
                })
                .catch(error => {
                    console.log(error);
                });
        },
        changeProductUnitData(data, manual = false) {
            let newData = {...data};
            if (manual) {
                //when ordered more
                newData.quantity = manual
            }

            this.priceDetails = newData;
            this.productPrice = newData.price
            this.productCount = newData.quantity
        },
        manualCount(event) {
            let manual = parseInt(event.target.value)

            const multiplesOf = this.product.orderedPrices[0].quantity;

            if (this.product.cdu_multiple_only === true || manual >= multiplesOf) {
                // Check manual is multiple of the lowest quantity.
                if (this.product.cdu_multiple_only && manual % multiplesOf !== 0) {
                    // Round to the nearest multiple of the lowest quantity.
                    manual = Math.round(manual / multiplesOf) * multiplesOf;
                    this.changeProductUnitData(this.product.orderedPrices[0], manual);
                    notyf.dismissAll();
                    notyf.open({
                        type: 'warning',
                        message: this.__('vue.product-pricing.quantity-adjusted-to-multiple-of-pack-size')
                    });
                }

                // Check stock.
                if (!this.checkStock(manual)) {
                    // Set to the nearest multiple of the maximum quantity.
                    manual = Math.floor(this.product.stock.quantity / multiplesOf) * multiplesOf;
                    this.changeProductUnitData(this.product.orderedPrices[0], manual);

                    return false;
                }

                for (let i = 0; i < this.product.orderedPrices.length; i++) {
                    let nextBreakPoint = i + 1;

                    //if manual is less than the minimum, get the minimum
                    let firstItem = this.product.orderedPrices[0];

                    if (manual < firstItem.quantity) {
                        notyf.dismissAll();
                        notyf.open({
                            type: 'error',
                            message: this.__('vue.product-pricing.minimum-available-count-is') + firstItem.quantity
                        });
                        this.changeProductUnitData(firstItem)
                        break
                    }

                    //if there is no next item, get the last one as next
                    let lastItem = this.product.orderedPrices[this.product.orderedPrices.length - 1];
                    let nextItem = this.product.orderedPrices[nextBreakPoint] ?? lastItem;

                    if (manual === this.product.orderedPrices[i].quantity) {
                        this.changeProductUnitData(this.product.orderedPrices[i]);
                        break;
                    }

                    //if the manual is equal to some breakpoint
                    if (manual === nextItem.quantity) {
                        this.changeProductUnitData(nextItem);
                        break;
                    }

                    //if manual is more than the last breakpoint, get the last
                    if (manual > lastItem.quantity) {
                        this.changeProductUnitData(lastItem, manual);
                        break;
                    }
                }
            }


            this.emitBasketCountUpdate()
        },
        toggleShowingStock() {
            if (this.isRep === true || this.isCallCentre === true) {
                this.showStock = !this.showStock;
            }
        },
        productsBasketCountUpdated(itemCount) {
            this.$emit('productsBasketCountUpdated', itemCount);
        },
        getOldPrice(){
            if (typeof this.product.orderedPrices !== 'undefined' && this.product.orderedPrices.length > 0) {
                for (let i = this.product.orderedPrices.length - 1; i >= 0; i--) {
                    if (this.productCount >= this.product.orderedPrices[i].quantity) {
                        this.oldPrice = this.product.orderedPrices[i].price;
                        break;
                    }
                }
            }

        }
    },
}
</script>

<style lang="scss" scoped>

</style>
